import { Record } from 'immutable';

import Hydrator from 'utils/Hydrator';

import Insight from './InsightModel';

const InsightsModelRecord = Record({
  facility: [],
  financial: [],
  deltas: [],
  creditReports: [],
});

export default class Insights extends InsightsModelRecord {
  static deserialize(jsonObject = {}) {
    const mapProperties = {
      facility: Hydrator.fromArray(Insight.deserialize),
      financial: Hydrator.fromArray(Insight.deserialize),
      deltas: Hydrator.fromArray(Insight.deserialize),
      creditReports: Hydrator.fromArray(Insight.deserialize),
    };

    const hydrated = Object.keys(jsonObject).reduce(Hydrator.assign(jsonObject, mapProperties), {});

    return new Insights(hydrated);
  }
}
